import { createSelector } from 'reselect';

import { State } from '../rootReducer';
import { LobareState, ActionTypes } from './types';

export const getLobareState = (state: State) => state.lobare;

export const getIsPending = createSelector([getLobareState], (s: LobareState) => s.state === ActionTypes.PENDING);
export const getLobare = createSelector([getLobareState], (s: LobareState) => s.data);
